import { render, staticRenderFns } from "./billT.vue?vue&type=template&id=2f2c3f90&scoped=true&"
import script from "./billT.vue?vue&type=script&lang=js&"
export * from "./billT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c3f90",
  null
  
)

export default component.exports